import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { XCircle } from "lucide-react";
import { MOTIVOS_CIERRE_OPCIONES, MOTIVOS_CIERRE } from "@/lib/estadosLeads";

export default function CierreLeadDialog({ open, onClose, onSubmit, isLoading, defaultMotivo = "perdido" }) {
  const [motivo, setMotivo] = useState(defaultMotivo);

  useEffect(() => {
    if (open) setMotivo(defaultMotivo);
  }, [open, defaultMotivo]);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <XCircle className="w-5 h-5 text-red-600" />
            Cerrar lead
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <Label className="text-sm text-gray-600 mb-2 block">¿Por qué cierras este lead?</Label>
          <div className="space-y-2">
            {MOTIVOS_CIERRE_OPCIONES.map(({ value, label }) => {
              const meta = MOTIVOS_CIERRE[value];
              return (
                <button
                  key={value}
                  type="button"
                  onClick={() => setMotivo(value)}
                  className={`w-full flex items-center gap-3 p-3 rounded-lg border-2 transition-all ${
                    motivo === value
                      ? "border-blue-500 bg-blue-50 dark:bg-blue-950"
                      : "border-gray-200 dark:border-gray-700 hover:border-gray-300"
                  }`}
                >
                  <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${meta.color} ${meta.text}`}>
                    {label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button onClick={() => onSubmit(motivo)} disabled={isLoading} className="bg-red-600 hover:bg-red-700">
            {isLoading ? "Cerrando..." : "Cerrar lead"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
